import { Vue } from 'vue-property-decorator';

export default class ScrollToMixin extends Vue {
    scrollTo(id) {
        document.querySelector(id).scrollIntoView({
            behavior: 'smooth'
        });
    }
}
